module.exports = __webpack_public_path__ + "static/mobile@2x-768x636-72014596864ee1f5f591d593cacc291e.png";